import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const displayTimer = window.setTimeout(() => setIsVisible(true), 25000);
    const hideTimer = window.setTimeout(() => setIsVisible(false), 33000);
    return () => {
      window.clearTimeout(displayTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-1">
      {isVisible && <motion.aside initial={{
      opacity: 0,
      x: -20,
      y: 24
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -20,
      y: 12
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} aria-label="Información de la oferta" className="fixed bottom-5 left-5 z-50 flex max-w-sm items-start gap-3 rounded-xl border border-stone-200 bg-white p-4 shadow-xl" data-id="element-2">
          <div className="mt-0.5 rounded-full bg-emerald-100 p-2 text-emerald-700" data-id="element-3">
            <CheckCircle2 className="h-5 w-5" aria-hidden="true" data-id="element-4" />
          </div>
          <div className="pr-5" data-id="element-5">
            <p className="text-sm font-bold text-stone-950" data-id="element-6">
              Todo el contenido está incluido por US$27
            </p>
            <p className="mt-1 text-xs leading-relaxed text-stone-500" data-id="element-7">
              Accede a la guía, los recursos prácticos y los cuatro bonos
              después de completar tu compra.
            </p>
          </div>
          <button type="button" onClick={() => setIsVisible(false)} className="absolute right-2 top-2 rounded p-1 text-stone-400 transition hover:text-stone-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500" aria-label="Cerrar mensaje" data-id="element-8">
            <X className="h-4 w-4" aria-hidden="true" data-id="element-9" />
          </button>
        </motion.aside>}
    </AnimatePresence>;
}